import {
  GET_INTRODUCTION_NOTICE_COUNT,
  GET_INTRODUCTION_NOTICE_COUNT_SUCCESS,
  GET_INTRODUCTION_NOTICE_COUNT_FAILURE,
  GET_INTRODUCTION_LIST,
  GET_INTRODUCTION_LIST_SUCCESS,
  GET_INTRODUCTION_LIST_FAILURE,
  GET_INTRODUCTION_DETAIL,
  GET_INTRODUCTION_DETAIL_SUCCESS,
  GET_INTRODUCTION_DETAIL_FAILURE,
  PATCH_INTRODUCTION_COMPLETE,
  PATCH_INTRODUCTION_COMPLETE_SUCCESS,
  PATCH_INTRODUCTION_COMPLETE_FAILURE,
  PRINT_INTRODUCTION,
  PRINT_INTRODUCTION_SUCCESS,
  PRINT_INTRODUCTION_FAILURE
} from './mutation-types'

export default {
  state: {
  },
  getters: {
  },
  actions: {
    [GET_INTRODUCTION_NOTICE_COUNT] ({ dispatch, commit }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiGet', { url: '/master/introductions/count', data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(GET_INTRODUCTION_NOTICE_COUNT_FAILURE)
              reject(res.data.error)
            } else {
              commit(GET_INTRODUCTION_NOTICE_COUNT_SUCCESS)
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          commit(GET_INTRODUCTION_NOTICE_COUNT_FAILURE)
          reject(err)
        })
      })
    },
    [GET_INTRODUCTION_LIST] ({ dispatch, commit }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiGet', { url: '/master/introductions', data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(GET_INTRODUCTION_LIST_FAILURE)
              reject(res.data.error)
            } else {
              commit(GET_INTRODUCTION_LIST_SUCCESS)
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          commit(GET_INTRODUCTION_LIST_FAILURE)
          reject(err)
        })
      })
    },
    [GET_INTRODUCTION_DETAIL] ({ dispatch, commit }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiGet', { url: `/master/introductions/${params.data.introduction_id}`, data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(GET_INTRODUCTION_DETAIL_FAILURE)
              reject(res.data.error)
            } else {
              commit(GET_INTRODUCTION_DETAIL_SUCCESS)
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          commit(GET_INTRODUCTION_DETAIL_FAILURE)
          reject(err)
        })
      })
    },
    [PATCH_INTRODUCTION_COMPLETE] ({ dispatch, commit }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiPatch', { url: `/master/introductions/${params.data.introduction_id}`, data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(PATCH_INTRODUCTION_COMPLETE_FAILURE)
              reject(res.data.error)
            } else {
              commit(PATCH_INTRODUCTION_COMPLETE_SUCCESS)
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          commit(PATCH_INTRODUCTION_COMPLETE_FAILURE)
          reject(err)
        })
      })
    },
    [PRINT_INTRODUCTION] ({ dispatch, commit }, params) {
      return new Promise((resolve, reject) => {
        dispatch('apiBlobDownload', { url: '/master/introductions/print_introduction', data: params.data })
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(PATCH_INTRODUCTION_COMPLETE_FAILURE)
              reject(res.data.error)
            } else {
              commit(PATCH_INTRODUCTION_COMPLETE_SUCCESS)
              resolve(res.data)
            }
          }
        })
        .catch(err => {
          commit(PATCH_INTRODUCTION_COMPLETE_FAILURE)
          reject(err)
        })
      })
    }
  },
  mutations: {
    [GET_INTRODUCTION_NOTICE_COUNT_FAILURE] () {
      console.log('GET_INTRODUCTION_NOTICE_COUNT_FAILURE')
    },
    [GET_INTRODUCTION_NOTICE_COUNT_SUCCESS] () {
      console.log('GET_INTRODUCTION_NOTICE_COUNT_SUCCESS')
    },
    [GET_INTRODUCTION_LIST_FAILURE] () {
      console.log('GET_INTRODUCTION_LIST_FAILURE')
    },
    [GET_INTRODUCTION_LIST_SUCCESS] () {
      console.log('GET_INTRODUCTION_LIST_SUCCESS')
    },
    [GET_INTRODUCTION_DETAIL_FAILURE] () {
      console.log('GET_INTRODUCTION_DETAIL_FAILURE')
    },
    [GET_INTRODUCTION_DETAIL_SUCCESS] () {
      console.log('GET_INTRODUCTION_DETAIL_SUCCESS')
    },
    [PATCH_INTRODUCTION_COMPLETE_FAILURE] () {
      console.log('PATCH_INTRODUCTION_COMPLETE_FAILURE')
    },
    [PATCH_INTRODUCTION_COMPLETE_SUCCESS] () {
      console.log('PATCH_INTRODUCTION_COMPLETE_SUCCESS')
    },
    [PRINT_INTRODUCTION_SUCCESS] () {
      console.log('PATCH_INTRODUCTION_COMPLETE_FAILURE')
    },
    [PRINT_INTRODUCTION_FAILURE] () {
      console.log('PATCH_INTRODUCTION_COMPLETE_SUCCESS')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/introduction.js